import { Component, OnInit } from '@angular/core';
import { CommsService } from '../../services/comms/comms.service';
import { DataService } from '../../services/data/data.service';
import { DisplayService } from '../../services/display/display.service';

@Component({
	selector: 'pcm-release-notes',
	templateUrl: './release-notes.component.html',
	styleUrls: ['./release-notes.component.scss']
})
export class ReleaseNotesComponent implements OnInit {

	releaseNotesList: string[] = [];
	releaseNoteDate: string;

	constructor(
		private commsService: CommsService,
		private displayService: DisplayService,
		private dataService: DataService
	) { }

	ngOnInit() {
		this.loadCurrentReleaseNotes();
	}

	loadCurrentReleaseNotes(): void {
		this.displayService.startLoading();
		this.commsService.getReleaseNotes().subscribe(res => {
			const successData = this.commsService.getSuccessData(res);
			this.releaseNotesList = successData['message'];
			// convert from unix time to local time display
			this.releaseNoteDate = this.dataService.formatLocalDate(new Date(successData['timestamp'] * 1000));
			this.displayService.endLoading();
		}, err => {
		this.commsService.handleAPIError('Load Release Notes', err);
		this.displayService.endLoading();
		});
	}
}
